import * as React from 'react'
import { lightTheme } from '@/customTheme'

/** Design-system "OK big" glyph: the phone panels' Done ✓. */
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={props.fill ?? lightTheme.colors.blackGray}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.3765 15.9921L17.7741 5.46821C18.1959 4.93956 18.9774 4.84433 19.5197 5.2555C20.062 5.66666 20.1597 6.42854 19.7379 6.95718L10.503 18.5318C10.0534 19.0952 9.20444 19.1602 8.67027 18.672L3.39316 13.8492C2.89196 13.3912 2.86657 12.6238 3.33645 12.1352C3.80632 11.6466 4.59354 11.6219 5.09474 12.0799L9.3765 15.9921Z"
    />
  </svg>
)
export default SvgComponent
